export default {
    "Click to Open": {
        pt: 'Clique para abrir'
    },
    "Skills and levels": {
        pt: 'Habilidades'
    },
    "Proefficiency": {
        pt: 'Proeficiência'
    },
    "Prefference": {
        pt: 'Preferência'
    },
    "Order by": {
        pt: 'Ordernar por'
    },
    "See more": {
        pt: 'Veja mais'
    },
    "Close": {
        pt: 'Fechar'
    },
    "Controls": {
        pt: 'Você pode utilizar as setas <- e -> para navegar, bem como ESC para voltar à tela inicial.',
        en: 'You can use <- and -> arrows to browse and ESC to exit.'
    }
}
